var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import * as DetectRTC from 'detectrtc';
function getDisabledMessage(options) {
    const { hasWebcam, hasMicrophonePermissions, hasWebcamPermissions, hasMicrophone } = options;
    if (!hasWebcam && !hasMicrophone) {
        return 'Unable to detect your microphone & camera. Please make sure they are properly connected.';
    }
    else if (!hasWebcam) {
        return 'Unable to detect your camera. Please make sure your camera is properly connected.';
    }
    else if (!hasMicrophone) {
        return 'Unable to detect your microphone. Please make sure your microphone is properly connected.';
    }
    else if (!hasWebcamPermissions && !hasMicrophonePermissions) {
        return 'Please check your browser permissions and settings to enable microphone & camera.';
    }
    else if (!hasWebcamPermissions) {
        return 'Please check your browser permissions and settings to enable camera.';
    }
    else if (!hasMicrophonePermissions) {
        return 'Please check your browser permissions and settings to enable microphone.';
    }
}
const useIsCameraAndMicAvailable = () => {
    const [micAvailable, setMicAvailable] = useState(true);
    const [camAvailable, setCamAvailable] = useState(true);
    const [hasMicrophonePermissions, setHasMicrophonePermissions] = useState(true);
    const [hasWebcamPermissions, setHasWebcamPermissions] = useState(true);
    const [disabledMessage, setDisabledMessage] = useState(undefined);
    useEffect(() => {
        const init = () => __awaiter(void 0, void 0, void 0, function* () {
            DetectRTC.load(() => {
                const { hasMicrophone, hasWebcam, isWebsiteHasMicrophonePermissions, isWebsiteHasWebcamPermissions, } = DetectRTC;
                setMicAvailable(hasMicrophone);
                setCamAvailable(hasWebcam);
                setHasMicrophonePermissions(isWebsiteHasMicrophonePermissions);
                setHasWebcamPermissions(isWebsiteHasWebcamPermissions);
                const message = getDisabledMessage({
                    hasMicrophone,
                    hasWebcam,
                    hasMicrophonePermissions: isWebsiteHasMicrophonePermissions,
                    hasWebcamPermissions: isWebsiteHasWebcamPermissions,
                });
                setDisabledMessage(message);
            });
        });
        init();
    }, []);
    return {
        micAvailable,
        camAvailable,
        hasMicrophonePermissions,
        hasWebcamPermissions,
        disabledMessage,
    };
};
export default useIsCameraAndMicAvailable;
//# sourceMappingURL=useIsCameraAndMicAvailable.js.map